import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { HybridAnnouncement } from '../components/HybridAnnouncement';
import { MultilingualCallout } from '../components/MultilingualCallout';
import { HowItWorks } from '../components/HowItWorks';
import { Benefits } from '../components/Benefits';
import { TrustStrip } from '../components/TrustStrip';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col w-full bg-slate-50" data-id="element-267">
      <Header data-id="element-268" />
      <main className="flex-grow" data-id="element-269">
        <Hero data-id="element-270" />
        <TrustStrip data-id="element-271" />
        <HybridAnnouncement data-id="element-272" />
        <MultilingualCallout data-id="element-273" />
        <HowItWorks data-id="element-274" />
        <Benefits data-id="element-275" />
        <Contact data-id="element-276" />
      </main>
      <Footer data-id="element-277" />
    </div>;
}